<template>
  <div>
    <b-row class="pt-2 pb-1">
      <b-col cols="6">
        <BreadcrumbMenu />
      </b-col>
    </b-row>
    <!-- Toastification loading content export -->
    <toastification-loading-content ref="loadingToast" />

    <b-card-group deck>
      <!-- Table Container Card -->
      <b-card class="m-2" no-body>
        <div class="m-2">
        <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize">{{ $t("table.entries") }}</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search')"
                />

                <b-button
                  @click="exportExcel()"
                  variant="success"
                  class="text-capitalize ml-1"
                  type="button"
                  :disabled="buttonExport"
                  v-b-tooltip.hover
                  :title="`${$t('messages.export.title')}`"
                >
                  <feather-icon icon="DownloadCloudIcon" size="15"/>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('no_record_found')"
          :sort-desc.sync="isSortDirDesc"
          @row-selected="onRowSelected"
          select-mode="single"
          selectable
        >
          <template #head()="data">
            <span> {{ $tc(data.label, 1) }}</span>
          </template>

          <template #head(actions)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #cell(priority)="data">
            <span>
              {{ getPriorityLabel(data.item.priority) }}
            </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                @click="confirmDelete(data.item.id)"
                v-if="$can('delete', 'HelpdeskTicket')"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50 text-capitalize">{{
                  $t("actions.delete")
                }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <Pagination
                :totalList="totalList"
                :currentPage="currentPage"
                @updatePagination="update"
                :perPage="perPage"
              >
              </Pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-card class="m-2 sticky-card showScroll" v-if="showObject" no-body>
        <div class="ml-auto float-rigth">
          <feather-icon
            icon="XIcon"
            class="mr-2 ml-auto float-rigth"
            style="cursor: pointer"
            size="30"
            @click="closeCard"
          />
        </div>

        <div
          v-if="loadingTicket"
          class="d-flex flex-column justify-content-center align-items-center"
          style="height: 300px;"
        >
          <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem;"
          />

          <span class="mt-2 text-muted">
            {{$t("actions.loading")}}
          </span>
        </div>
        <div v-else class="mx-2">
          <div>
              <b-card class="mb-0">
                <table class="table table-sm">
                  <tr>
                    <th>Ticket:</th>
                    <td># {{ selectedObject.id }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("helpdesk.ticket.name") }}:</th>
                    <td>{{ selectedObject.name }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("helpdesk.ticket.from") }}:</th>
                    <td>{{ selectedObject.from }}</td>
                  </tr>
                  <tr>
                    <th>{{ $tc("helpdesk.ticket.title", 1) }}:</th>
                    <td>{{ selectedObject.subject }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("helpdesk.ticket.message") }}:</th>
                    <td>{{ selectedObject.message }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("helpdesk.ticket.priority") }}:</th>
                    <td>{{ priorityTicket }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("helpdesk.ticket.status") }}:</th>
                    <td>{{ statusTicket }} </td>
                  </tr>
                  <tr>
                    <th>{{ $t("helpdesk.group.title") }}:</th>
                    <td>{{ selectedObject.group[0].name }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t("helpdesk.ticket.type") }}:</th>
                    <td>{{ selectedObject.ticket_type ? selectedObject.ticket_type.name : "" }}</td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <th
                      v-for="(a, index) in getTicket.ticket.threads[0]
                        .attachments"
                      :key="index"
                    >
                      <img
                        width="50px"
                        height="50px"
                        class="img-thumbnail"
                        :src="`${urlUvdesk}` + a.relativePath"
                        alt=""
                        @click="openImageModal(`${urlUvdesk}` + a.relativePath)"
                        v-b-modal.image_modal
                      />
                    </th>
                  </tr>
                </table>
              </b-card>
            </div>
          <div v-for="(t, index) in getTicket.ticket.threads" :key="index">
              <b-card v-if="index > 0" class="mb-0">
                <div>
                  <p class="badge mb-2 mb-sm-0 badge-dark text-uppercase">
                    {{ t.user.name }}
                  </p>
                  <p class="text-uppercase float-right">{{ t.createdAt }}</p>
                </div>
                <p>{{ t.message }}</p>
                <table>
                  <tr>
                    <th v-for="(a, index) in t.attachments" :key="index">
                      <img
                        width="50px"
                        height="50px"
                        class="img-thumbnail"
                        :src="`${urlUvdesk}` + a.relativePath"
                        alt=""
                        @click="openImageModal(`${urlUvdesk}` + a.relativePath)"
                        v-b-modal.image_modal
                      />
                    </th>
                  </tr>
                </table>
              </b-card>
              <hr style="margin: 0px">
            </div>
        </div>
      </b-card>
    </b-card-group>
    <image-modal />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, computed } from "@vue/composition-api";
import useList from "./useList";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "@axios";
import ImageModal from "../../components/GridView/widgets/ImageModal.vue";

export default {
  components: {
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    BreadcrumbMenu,
    ToastificationLoadingContent,
    ValidationProvider,
    ValidationObserver,
    ImageModal,
  },

  setup(_, context) {
    const update = (data) => {
      currentPage.value = data;
    };

    const loadingToast = ref(null);
    const action = ref("");
    const { t } = useI18nUtils();
    const trans = {
      "messages.export.download": t("messages.export.download"),
      "messages.export.Generating_file": t("messages.export.Generating_file"),
      "messages.error.server_error": t("messages.error.server_error"),
      "messages.delete.title": t("messages.delete.title"),
      "messages.delete.body": t("messages.delete.body"),
      "actions.delete": t("actions.delete"),
      "actions.cancel": t("actions.cancel"),
    };
    const exportExcel = () => {
      action.value == "export";
      buttonExport.value = true;
      loadingToast.value.show(
        trans["messages.export.download"],
        trans["messages.export.Generating_file"],
        "secondary"
      );
      store
        .dispatch("helpdesk_ticket/export", {
          q: searchQuery.value,
          max: perPage.value,
          "page[n]": currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          action: "export",
        })
        .then(() => {})
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: trans["messages.error.server_error"],
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          loadingToast.value.close();
          buttonExport.value = false;
        });
    };

    const buttonExport = ref(false);
    const isSidebarActive = ref(false);
    const itemEdit = ref({});
    const isAdd = ref(false);
    const toast = useToast();
    const selectedObject = ref(null);
    const showObject = ref(false);
    const loadingTicket = ref(false);

    const openEdit = (item) => {
      isSidebarActive.value = true;
      itemEdit.value = item;
      isAdd.value = false;
    };

    const onRowSelected = async (item) => {
      if (!item[0]) return;

      selectedObject.value = item[0];
      showObject.value = true;
      loadingTicket.value = true;

      try {
        await refreshTicket(item[0].id);
      } finally {
        loadingTicket.value = false;
      }
    };

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      groupsOptions,
    } = useList();

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: context.parent.$i18n.t("messages.delete.title"),
        text: context.parent.$i18n.t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: context.parent.$i18n.t("actions.delete"),
        cancelButtonText: context.parent.$i18n.t("actions.cancel"),
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("helpdesk_ticket/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: "Eliminado correctamente",
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "No eliminado",
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isAdd.value = true;
      isSidebarActive.value = true;
    };

    const statusTciketOptions = ref([
      { value: 1, label: "Open" },
      { value: 2, label: "Pending" },
      { value: 3, label: "Resolved" },
      { value: 4, label: "Closed" },
    ]);

    const getTicket = ref([])
    const refreshTicket = async(id) => {
      const { data } = await axios.get("v1/helpdesk/ticket/" + id);
      getTicket.value = data.data;
    }

    const openImageModal = async (imageUrl) => {
      await store.dispatch("image_modal/imageUrl", imageUrl);
    }

    const statusTicket = computed(() => {
      const status = getTicket.value?.ticket?.status
      const found = statusTciketOptions.value.find((item) => item.label.toLowerCase() === status.toLowerCase());
      return found ? found.label : "";
    })

    const priorityTicket = computed(() => {
      const priority = Number(getTicket.value?.ticket?.priority);
      const found = priorityTickeOptions.value.find((item) => item.value === priority);
      return found ? found.label : "";
    })

    const getPriorityLabel = (priority) => {
      const value = Number(priority);
      const found = priorityTickeOptions.value.find((item) => item.value === value);
      return found ? found.label : "";
    };

    const priorityTickeOptions = ref([
      { value: 1, label: "Low" },
      { value: 2, label: "Medium" },
      { value: 3, label: "High" },
      { value: 4, label: "Urgent" },
    ]);

    const closeCard = () => {
      showObject.value = null;
    };

    return {
      priorityTickeOptions,
      getTicket,
      openImageModal,
      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      update,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      loadingToast,
      action,
      exportExcel,
      buttonExport,
      selectedObject,
      showObject,
      loadingTicket,
      onRowSelected,
      statusTciketOptions,
      priorityTicket,
      groupsOptions,
      statusTicket,
      closeCard,
      urlUvdesk: window.__env.VUE_APP_UVDESK,
      getPriorityLabel,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.message-t {
  max-width: 250px;
}

.sticky-card {
  position: sticky;
  top: 6rem;
  height: 80vh;
  overflow-y: auto;
}

</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
